"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SokIcon = exports.IconMap = void 0;
var React = require("react");
var CheckSquare_1 = require("./Icon/CheckSquare");
var Download_1 = require("./Icon/Download");
var Dwg_1 = require("./Icon/Dwg");
var ExclamationTriangle_1 = require("./Icon/ExclamationTriangle");
var Ifc_1 = require("./Icon/Ifc");
var PlayCircle_1 = require("./Icon/PlayCircle");
var TimesCircle_1 = require("./Icon/TimesCircle");
var TimesSquare_1 = require("./Icon/TimesSquare");
var UploadIFCGreen_1 = require("./Icon/UploadIFCGreen");
var UploadIFCOrange_1 = require("./Icon/UploadIFCOrange");
var UploadIFCPink_1 = require("./Icon/UploadIFCPink");
var UploadDWGGreen_1 = require("./Icon/UploadDWGGreen");
var UploadDWGPink_1 = require("./Icon/UploadDWGPink");
var recompose_1 = require("recompose");
var classNames = require("classnames");
// import './styles.scss'
/*
 * Note, when adding Icons make sure that they have unique classnames for styles!
 * So use find and replace forexample cls-2 -> cls-dwg-2 so that styles dont bleed
*/
var IconMap = function (props) { return ({
    'sok-icon-check-square': React.createElement(CheckSquare_1.default, __assign({}, props)),
    'sok-icon-download-cloud': React.createElement(Download_1.default, __assign({}, props)),
    'sok-icon-dwg': React.createElement(Dwg_1.default, __assign({}, props)),
    'sok-icon-exclamation-triangle': React.createElement(ExclamationTriangle_1.default, __assign({}, props)),
    'sok-icon-ifc': React.createElement(Ifc_1.default, __assign({}, props)),
    'sok-icon-play-circle': React.createElement(PlayCircle_1.default, __assign({}, props)),
    'sok-icon-times-circle': React.createElement(TimesCircle_1.default, __assign({}, props)),
    'sok-icon-times-square': React.createElement(TimesSquare_1.default, __assign({}, props)),
    'sok-icon-3d-green': React.createElement(UploadIFCGreen_1.default, __assign({}, props)),
    'sok-icon-3d-orange': React.createElement(UploadIFCOrange_1.default, __assign({}, props)),
    'sok-icon-3d-pink': React.createElement(UploadIFCPink_1.default, __assign({}, props)),
    'sok-icon-2d-green': React.createElement(UploadDWGGreen_1.default, __assign({}, props)),
    'sok-icon-2d-pink': React.createElement(UploadDWGPink_1.default, __assign({}, props))
}); };
exports.IconMap = IconMap;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('SokIcon'), recompose_1.pure);
var regExp = /sok-icon-([\w\-]+)/i;
exports.SokIcon = enhance(function (props) {
    var result = regExp.exec(props.className);
    if (result.length > 0) {
        var icons_1 = (0, exports.IconMap)(props);
        var iconName = result.find(function (className) { return typeof icons_1[className] === 'object'; });
        var icon = icons_1[iconName];
        if (typeof icon === 'object') {
            return React.cloneElement(icon, __assign(__assign({}, props), { className: classNames('sok-icon', props.className, props.size && 'sok-icon-' + props.size) }));
        }
    }
    return React.createElement("span", null, "Unknown icon class");
});
//# sourceMappingURL=index.js.map